import { useEffect, useRef, useState, useMemo } from 'react';

export function useTimer(initialTime) {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isExpired, setIsExpired] = useState(false);
  const intervalRef = useRef(null);

  const startTimer = () => {
    if (intervalRef.current) return;

    setIsExpired(false);

    intervalRef.current = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1000) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          setIsExpired(true);
          return 0;
        }
        return prev - 1000;
      });
    }, 1000);
  };

  const stopTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const resetTimer = () => {
    stopTimer();
    setTimeLeft(initialTime);
    setIsExpired(false);
  };

  const timeLeftFormatted = useMemo(() => {
    const totalSeconds = Math.floor(timeLeft / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }, [timeLeft]);

  useEffect(() => {
    return () => stopTimer();
  }, []);

  return {
    timeLeft,
    timeLeftFormatted,
    isExpired,
    startTimer,
    stopTimer,
    resetTimer,
  };
}
